export default "__VITE_ASSET__5uTAii6h__"